/**
 * FAMILY GRID - Column Configuration by Product Type
 * 
 * Defines which columns/specs to show for each product category.
 * McMaster-style: different tables for different product types.
 */

window.FamilyGridColumns = {
  
  // Default columns if no match found
  // Priority order: Size, Length, Material, Grade (finish is dynamic - hidden for stainless)
  default: [
    { key: 'diameter', label: 'Size', sortable: true, filterable: true },
    { key: 'length', label: 'Length', sortable: true, filterable: true },
    { key: 'material', label: 'Material', sortable: true, filterable: true },
    { key: 'grade', label: 'Grade', sortable: true, filterable: true },
    { key: 'finish', label: 'Finish', sortable: false, filterable: true },  // Dynamic: hidden for stainless
    { key: 'packQty', label: 'Pack Qty', sortable: false, filterable: false, align: 'center' },
    { key: 'price', label: 'Price', sortable: true, filterable: false, align: 'right', format: 'money' },
  ],

  // =============================================
  // SCREWS & BOLTS
  // =============================================
  
  'Socket Head Cap Screws': [
    { key: 'diameter', label: 'Thread', sortable: true, filterable: true },
    { key: 'length', label: 'Length', sortable: true, filterable: true },
    { key: 'threadStyle', label: 'Thread', sortable: false, filterable: true }, // Full vs Partial
    { key: 'material', label: 'Material', sortable: true, filterable: true },
    { key: 'grade', label: 'Grade', sortable: false, filterable: true },
    { key: 'finish', label: 'Finish', sortable: false, filterable: false },
    { key: 'hexKeySize', label: 'Key Size', sortable: false, filterable: false },
    { key: 'packQty', label: 'Pack', sortable: false, filterable: false, align: 'center' },
    { key: 'price', label: 'Price', sortable: true, filterable: false, align: 'right', format: 'money' },
  ],

  'Hex Cap Screws': [
    { key: 'diameter', label: 'Thread', sortable: true, filterable: true },
    { key: 'length', label: 'Length', sortable: true, filterable: true },
    { key: 'threadStyle', label: 'Thread', sortable: false, filterable: true },
    { key: 'material', label: 'Material', sortable: true, filterable: true },
    { key: 'grade', label: 'Grade', sortable: false, filterable: true },
    { key: 'finish', label: 'Finish', sortable: false, filterable: false },
    { key: 'acrossFlats', label: 'A/F', sortable: false, filterable: false },
    { key: 'packQty', label: 'Pack', sortable: false, filterable: false, align: 'center' },
    { key: 'price', label: 'Price', sortable: true, filterable: false, align: 'right', format: 'money' },
  ],

  'Machine Screws': [
    { key: 'diameter', label: 'Thread', sortable: true, filterable: true },
    { key: 'length', label: 'Length', sortable: true, filterable: true },
    { key: 'headStyle', label: 'Head', sortable: false, filterable: true },
    { key: 'driveType', label: 'Drive', sortable: false, filterable: true },
    { key: 'material', label: 'Material', sortable: true, filterable: true },
    { key: 'finish', label: 'Finish', sortable: false, filterable: false },
    { key: 'packQty', label: 'Pack', sortable: false, filterable: false, align: 'center' },
    { key: 'price', label: 'Price', sortable: true, filterable: false, align: 'right', format: 'money' },
  ],

  'Set Screws': [
    { key: 'diameter', label: 'Size', sortable: true, filterable: true },
    { key: 'length', label: 'Length', sortable: true, filterable: true },
    { key: 'material', label: 'Material', sortable: true, filterable: true },
    { key: 'grade', label: 'Grade', sortable: true, filterable: true },
    { key: 'finish', label: 'Finish', sortable: false, filterable: true },  // Dynamic: hidden for stainless
    { key: 'pointType', label: 'Point', sortable: false, filterable: true },
    { key: 'hexKeySize', label: 'Hex Key', sortable: false, filterable: false },
    { key: 'packQty', label: 'Pack Qty', sortable: false, filterable: false, align: 'center' },
    { key: 'price', label: 'Price', sortable: true, filterable: false, align: 'right', format: 'money' },
  ],

  'Wood Screws': [
    { key: 'diameter', label: 'Size', sortable: true, filterable: true },
    { key: 'length', label: 'Length', sortable: true, filterable: true },
    { key: 'headStyle', label: 'Head', sortable: false, filterable: true },
    { key: 'driveType', label: 'Drive', sortable: false, filterable: true },
    { key: 'material', label: 'Material', sortable: true, filterable: true },
    { key: 'finish', label: 'Finish', sortable: false, filterable: false },
    { key: 'packQty', label: 'Pack', sortable: false, filterable: false, align: 'center' },
    { key: 'price', label: 'Price', sortable: true, filterable: false, align: 'right', format: 'money' },
  ],

  'Self-Tapping Screws': [
    { key: 'diameter', label: 'Size', sortable: true, filterable: true },
    { key: 'length', label: 'Length', sortable: true, filterable: true },
    { key: 'headStyle', label: 'Head', sortable: false, filterable: true },
    { key: 'driveType', label: 'Drive', sortable: false, filterable: true },
    { key: 'pointType', label: 'Point', sortable: false, filterable: true },
    { key: 'material', label: 'Material', sortable: true, filterable: true },
    { key: 'finish', label: 'Finish', sortable: false, filterable: false },
    { key: 'packQty', label: 'Pack', sortable: false, filterable: false, align: 'center' },
    { key: 'price', label: 'Price', sortable: true, filterable: false, align: 'right', format: 'money' },
  ],

  'Self-Drilling Screws': [
    { key: 'diameter', label: 'Size', sortable: true, filterable: true },
    { key: 'length', label: 'Length', sortable: true, filterable: true },
    { key: 'headStyle', label: 'Head', sortable: false, filterable: true },
    { key: 'driveType', label: 'Drive', sortable: false, filterable: true },
    { key: 'material', label: 'Material', sortable: true, filterable: true },
    { key: 'finish', label: 'Finish', sortable: false, filterable: false },
    { key: 'packQty', label: 'Pack', sortable: false, filterable: false, align: 'center' },
    { key: 'price', label: 'Price', sortable: true, filterable: false, align: 'right', format: 'money' },
  ],

  'Drywall Screws': [
    { key: 'diameter', label: 'Size', sortable: true, filterable: true },
    { key: 'length', label: 'Length', sortable: true, filterable: true },
    { key: 'headStyle', label: 'Head', sortable: false, filterable: true },
    { key: 'pointType', label: 'Point', sortable: false, filterable: true },
    { key: 'finish', label: 'Finish', sortable: false, filterable: false },
    { key: 'packQty', label: 'Pack', sortable: false, filterable: false, align: 'center' },
    { key: 'price', label: 'Price', sortable: true, filterable: false, align: 'right', format: 'money' },
  ],

  // =============================================
  // NUTS
  // =============================================

  'Hex Nuts': [
    { key: 'diameter', label: 'Thread', sortable: true, filterable: true },
    { key: 'material', label: 'Material', sortable: true, filterable: true },
    { key: 'grade', label: 'Grade', sortable: false, filterable: true },
    { key: 'finish', label: 'Finish', sortable: false, filterable: false },
    { key: 'acrossFlats', label: 'Width (A/F)', sortable: false, filterable: false },
    { key: 'packQty', label: 'Pack', sortable: false, filterable: false, align: 'center' },
    { key: 'price', label: 'Price', sortable: true, filterable: false, align: 'right', format: 'money' },
  ],

  'Nylon Insert Lock Nuts': [
    { key: 'diameter', label: 'Thread', sortable: true, filterable: true },
    { key: 'material', label: 'Material', sortable: true, filterable: true },
    { key: 'grade', label: 'Grade', sortable: false, filterable: true },
    { key: 'finish', label: 'Finish', sortable: false, filterable: false },
    { key: 'acrossFlats', label: 'Width (A/F)', sortable: false, filterable: false },
    { key: 'packQty', label: 'Pack', sortable: false, filterable: false, align: 'center' },
    { key: 'price', label: 'Price', sortable: true, filterable: false, align: 'right', format: 'money' },
  ],

  'Flange Nuts': [
    { key: 'diameter', label: 'Thread', sortable: true, filterable: true },
    { key: 'material', label: 'Material', sortable: true, filterable: true },
    { key: 'grade', label: 'Grade', sortable: false, filterable: true },
    { key: 'finish', label: 'Finish', sortable: false, filterable: false },
    { key: 'packQty', label: 'Pack', sortable: false, filterable: false, align: 'center' },
    { key: 'price', label: 'Price', sortable: true, filterable: false, align: 'right', format: 'money' },
  ],

  'Coupling Nuts': [
    { key: 'diameter', label: 'Thread', sortable: true, filterable: true },
    { key: 'length', label: 'Length', sortable: true, filterable: true },
    { key: 'material', label: 'Material', sortable: true, filterable: true },
    { key: 'finish', label: 'Finish', sortable: false, filterable: false },
    { key: 'acrossFlats', label: 'Width (A/F)', sortable: false, filterable: false },
    { key: 'packQty', label: 'Pack', sortable: false, filterable: false, align: 'center' },
    { key: 'price', label: 'Price', sortable: true, filterable: false, align: 'right', format: 'money' },
  ],

  // =============================================
  // WASHERS
  // =============================================

  'Flat Washers': [
    { key: 'diameter', label: 'Bolt Size', sortable: true, filterable: true },
    { key: 'id', label: 'ID', sortable: true, filterable: false },
    { key: 'od', label: 'OD', sortable: true, filterable: false },
    { key: 'thickness', label: 'Thick', sortable: false, filterable: false },
    { key: 'material', label: 'Material', sortable: true, filterable: true },
    { key: 'finish', label: 'Finish', sortable: false, filterable: false },
    { key: 'packQty', label: 'Pack', sortable: false, filterable: false, align: 'center' },
    { key: 'price', label: 'Price', sortable: true, filterable: false, align: 'right', format: 'money' },
  ],

  'Lock Washers': [
    { key: 'diameter', label: 'Bolt Size', sortable: true, filterable: true },
    { key: 'id', label: 'ID', sortable: true, filterable: false },
    { key: 'od', label: 'OD', sortable: true, filterable: false },
    { key: 'material', label: 'Material', sortable: true, filterable: true },
    { key: 'finish', label: 'Finish', sortable: false, filterable: false },
    { key: 'packQty', label: 'Pack', sortable: false, filterable: false, align: 'center' },
    { key: 'price', label: 'Price', sortable: true, filterable: false, align: 'right', format: 'money' },
  ],

  'Fender Washers': [
    { key: 'diameter', label: 'Bolt Size', sortable: true, filterable: true },
    { key: 'id', label: 'ID', sortable: true, filterable: false },
    { key: 'od', label: 'OD', sortable: true, filterable: false },
    { key: 'material', label: 'Material', sortable: true, filterable: true },
    { key: 'finish', label: 'Finish', sortable: false, filterable: false },
    { key: 'packQty', label: 'Pack', sortable: false, filterable: false, align: 'center' },
    { key: 'price', label: 'Price', sortable: true, filterable: false, align: 'right', format: 'money' },
  ],

  // =============================================
  // RIVETS
  // =============================================

  'Blind Rivets': [
    { key: 'diameter', label: 'Diameter', sortable: true, filterable: true },
    { key: 'gripRange', label: 'Grip Range', sortable: true, filterable: true },
    { key: 'headStyle', label: 'Head', sortable: false, filterable: true },
    { key: 'bodyMaterial', label: 'Body', sortable: false, filterable: true },
    { key: 'mandrelMaterial', label: 'Mandrel', sortable: false, filterable: true },
    { key: 'packQty', label: 'Pack', sortable: false, filterable: false, align: 'center' },
    { key: 'price', label: 'Price', sortable: true, filterable: false, align: 'right', format: 'money' },
  ],

  // =============================================
  // ANCHORS
  // =============================================

  'Wedge Anchors': [
    { key: 'diameter', label: 'Diameter', sortable: true, filterable: true },
    { key: 'length', label: 'Length', sortable: true, filterable: true },
    { key: 'embedDepth', label: 'Embed', sortable: false, filterable: false },
    { key: 'material', label: 'Material', sortable: true, filterable: true },
    { key: 'finish', label: 'Finish', sortable: false, filterable: false },
    { key: 'packQty', label: 'Pack', sortable: false, filterable: false, align: 'center' },
    { key: 'price', label: 'Price', sortable: true, filterable: false, align: 'right', format: 'money' },
  ],

  'Concrete Screws': [
    { key: 'diameter', label: 'Size', sortable: true, filterable: true },
    { key: 'length', label: 'Length', sortable: true, filterable: true },
    { key: 'headStyle', label: 'Head', sortable: false, filterable: true },
    { key: 'material', label: 'Material', sortable: true, filterable: true },
    { key: 'finish', label: 'Finish', sortable: false, filterable: false },
    { key: 'packQty', label: 'Pack', sortable: false, filterable: false, align: 'center' },
    { key: 'price', label: 'Price', sortable: true, filterable: false, align: 'right', format: 'money' },
  ],

  // =============================================
  // PINS
  // =============================================

  'Cotter Pins': [
    { key: 'diameter', label: 'Diameter', sortable: true, filterable: true },
    { key: 'length', label: 'Length', sortable: true, filterable: true },
    { key: 'material', label: 'Material', sortable: true, filterable: true },
    { key: 'finish', label: 'Finish', sortable: false, filterable: false },
    { key: 'packQty', label: 'Pack', sortable: false, filterable: false, align: 'center' },
    { key: 'price', label: 'Price', sortable: true, filterable: false, align: 'right', format: 'money' },
  ],

  'Dowel Pins': [
    { key: 'diameter', label: 'Diameter', sortable: true, filterable: true },
    { key: 'length', label: 'Length', sortable: true, filterable: true },
    { key: 'material', label: 'Material', sortable: true, filterable: true },
    { key: 'finish', label: 'Finish', sortable: false, filterable: false },
    { key: 'packQty', label: 'Pack', sortable: false, filterable: false, align: 'center' },
    { key: 'price', label: 'Price', sortable: true, filterable: false, align: 'right', format: 'money' },
  ],

  // =============================================
  // THREADED ROD
  // =============================================

  'Threaded Rod': [
    { key: 'diameter', label: 'Thread', sortable: true, filterable: true },
    { key: 'length', label: 'Length', sortable: true, filterable: true },
    { key: 'material', label: 'Material', sortable: true, filterable: true },
    { key: 'grade', label: 'Grade', sortable: false, filterable: true },
    { key: 'finish', label: 'Finish', sortable: false, filterable: false },
    { key: 'price', label: 'Price', sortable: true, filterable: false, align: 'right', format: 'money' },
  ],


  // =============================================
  // HELPER: Get columns for a product type
  // =============================================

  getColumnsForType: function(productType, options = {}) {
    let columns;
    
    // Try exact match first
    if (this[productType]) {
      columns = this[productType];
    } else {
      // Try partial match (e.g., "Socket Head Cap Screw, Full Thread" → "Socket Head Cap Screws")
      const normalizedType = productType.toLowerCase();
      
      for (const key of Object.keys(this)) {
        if (key === 'default' || key === 'getColumnsForType' || key === 'metafieldKeyMap' || key === 'shouldHideFinish') continue;
        if (normalizedType.includes(key.toLowerCase().replace(/s$/, ''))) {
          columns = this[key];
          break;
        }
      }
    }

    // Fallback to default
    if (!columns) columns = this.default;
    
    // Dynamic finish handling: hide finish column for stainless products
    if (options.hideFinish) {
      columns = columns.filter(col => col.key !== 'finish');
    }
    
    return columns;
  },
  
  // =============================================
  // HELPER: Determine if finish should be hidden
  // =============================================
  
  shouldHideFinish: function(products) {
    if (!products || products.length === 0) return false;
    
    // Check if ALL products are stainless - if so, hide finish
    const stainlessKeywords = ['stainless', '18-8', '304', '316', 'a2', 'a4', 'ss'];
    
    const allStainless = products.every(p => {
      const material = (p.material || '').toLowerCase();
      return stainlessKeywords.some(kw => material.includes(kw));
    });
    
    return allStainless;
  },

  // =============================================
  // HELPER: Map metafield keys to display values
  // =============================================

  metafieldKeyMap: {
    'diameter': 'diameter_nominal_',
    'length': 'length_nominal_',
    'material': 'material',
    'grade': 'grade',
    'finish': 'finish',
    'headStyle': 'head_style',
    'driveType': 'drive_type',
    'threadStyle': 'thread_style',
    'pointType': 'point_type',
    'hexKeySize': 'hex_key_size',
    'acrossFlats': 'across_flats',
    'packQty': 'pack_qty',
    'perPiecePrice': 'per_piece_price',
    'bodyMaterial': 'body_material',
    'mandrelMaterial': 'mandrel_material',
    'od': 'od',
    'id': 'id',
    'thickness': 'thickness',
    'gripRange': 'grip_range',
    'embedDepth': 'embed_depth'
  }

};
